import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Copyright from '../../components/Copyright';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  authSubmit: {
    margin: 25
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
});

const enhancer = compose(
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const smsAuth = enhancer(({ classes, handleRedirect }) => {
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h3" align="center">
          ごちめし
          <br />
          管理システム
        </Typography>
        <Avatar className={classes.avatar}>
          <MailOutlineIcon />
        </Avatar>
        <Typography component="h2" variant="h5">
          SMS認証
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            name="tel"
            label="電話番号"
            type="tel"
            id="tel"
          />
          <Button
            variant="contained"
            color="primary"
            className={classes.authSubmit}
          >
            認証番号を送信
          </Button>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="auth-code"
            label="SMS認証コード"
            type="text"
            id="auth-code"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => {
              handleRedirect('/reset_complete');
            }}
          >
            パスワード再設定
          </Button>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
});

export default withRouter(withStyles(styles)(smsAuth));
